import { Box, Button, Typography } from "@mui/material";
import { StyledShipLights } from "./ShipLights.styled";
import { useEffect, useMemo, useState } from "react";
import { generateQuiz } from "./ShipLights.utils";
import { QuizOption, QuizQuestion, ShipLightsData } from "./ShipLights.data";

export const ShipLights = () => {
  const [score, setScore] = useState<number>(0);
  const [quizIndex, setQuizIndex] = useState<number>(0);
  const [selectedAnswerId, setSelectedAnswerId] = useState<string>("");
  const [answers, setAnswers] = useState<QuizOption[]>([]);

  const quizItemCount = 20;

  const quiz = useMemo(() => {
    return generateQuiz(ShipLightsData, quizItemCount);
  }, []);

  const handleSubmit = () => {
    if (selectedAnswerId === quiz[quizIndex].correctAnswerId)
      setScore(score + 1);
    const answer = quiz[quizIndex].options.find(
      (o) => o.id === selectedAnswerId,
    );
    setAnswers((prev) => [...prev, answer!]);

    if (score != quizItemCount) setQuizIndex(quizIndex + 1);
    setSelectedAnswerId("");
  };

  useEffect(() => {
    console.log(answers)
  }, [answers])

  const reset = () => {
    setQuizIndex(0);
    setScore(0);
  };

  return (
    <StyledShipLights>
      {quizIndex < quizItemCount ? (
        <Box className="quiz">
          <Box className="imageWrapper">
            <img src={`${quiz[quizIndex].imgSrc}.png`} />
          </Box>
          <Box className="answers">
            {quiz[quizIndex].options.map((quizOption) => (
              <label>
                <input
                  type="radio"
                  name="answer"
                  value={quizOption.id}
                  checked={selectedAnswerId === quizOption.id}
                  onChange={(e) => setSelectedAnswerId(e.target.value)}
                />
                <Typography variant="h5">{quizOption.description}</Typography>
              </label>
            ))}
          </Box>
          <Box className="buttons">
            <Button onClick={handleSubmit}>Volgende</Button>
          </Box>
        </Box>
      ) : (
        <Box className="result">
          <Box className="header">
            <Typography variant="h2">
              Score: {score}/{quizItemCount}
            </Typography>
            <Button onClick={reset}>Begin opnieuw</Button>
          </Box>

          <Box className="resultAnswers">
            {quiz.map((quizItem, index) => (
              <Box className="quizAnswer">
                {quizItem.options.map((quizOption) => (
                  <label
                    className={`${
                      quizOption.id === quizItem.correctAnswerId
                        ? "correct"
                        : answers[index].id === quizOption.id
                          ? "wrong"
                          : ""
                    }`}>
                    <input
                      type="radio"
                      name="answer"
                      checked={selectedAnswerId === quizOption.id}
                      disabled
                    />
                    <Typography variant="h5">
                      {quizOption.description}
                    </Typography>
                  </label>
                ))}
              </Box>
            ))}
          </Box>
        </Box>
      )}
    </StyledShipLights>
  );
};
